export default defineNuxtRouteMiddleware(async (to) => {
  const facilitySearch = useFacilitySearch();
  const searchStore = useSearchStore();

  if (true) {

    // Only clear overNight filter if coming to search from NOT a search route
    // This prevents the filter from being removed when changing search criteria
    if(to.fullPath.includes('/search')) {
      searchStore.setIsOvernight(false);
    }

    if(to.fullPath.includes('/search')) {
      if (to.query.collection) {
        await useSearchByCollection(
          to.query.collection,
          to.query.checkinDate,
          to.query.checkoutDate
        );
        return;
      }

      facilitySearch.setParams(to.query);

      await useSearch(
        to.query.facility,
        to.query.checkinDate,
        to.query.checkoutDate || ''
      );
      return;
    }
  }
});
